import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import {
  METRIC_DECIMAL_CHANGE_EXTENSION,
  METRIC_DURATION_CHANGE_EXTENSION,
  METRIC_LABELS_CHANGE_EXTENSION,
  METRIC_MEASUREMENT_CONFIG_SUPPRESS_EXTENSION,
  METRIC_OWNER_CHANGE_EXTENSION,
  METRIC_PREFERRED_DIRECTION_CHANGE_EXTENSION,
  METRIC_STRING_CHANGE_EXTENSION,
  METRIC_VARIANCE_REDUCTION_CONFIG_CHANGE_EXTENSION,
} from './metric/components/MetricUpdatesSidebar';
import {
  ExternalRoutes,
  Routes,
  measurementsRouteImplRef,
  rootRouteRef,
} from './routes';

export const metricsPlugin = createPlugin({
  id: 'metrics',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindMetricsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(metricsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...metricsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceMetricsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceMetricsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-metrics", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);

export const ConfidenceMetricsExtension = metricsPlugin.provide(
  createComponentExtension({
    name: 'ConfidenceMetricsExtension',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-metrics-extension", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
    },
  }),
);

export const ConfidenceMeasurementsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceMeasurementsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-measurements", webpackPrefetch: 10 */ './MeasurementsRouter'
      ).then(m => m.MeasurementsRouter),
    mountPoint: measurementsRouteImplRef,
  }),
);

// Metric change extensions
export const MetricStringChangeExtension = metricsPlugin.provide(
  METRIC_STRING_CHANGE_EXTENSION,
);
export const MetricOwnerChangeExtension = metricsPlugin.provide(
  METRIC_OWNER_CHANGE_EXTENSION,
);
export const MetricLabelsChangeExtension = metricsPlugin.provide(
  METRIC_LABELS_CHANGE_EXTENSION,
);
export const MetricDurationChangeExtension = metricsPlugin.provide(
  METRIC_DURATION_CHANGE_EXTENSION,
);
export const MetricDecimalChangeExtension = metricsPlugin.provide(
  METRIC_DECIMAL_CHANGE_EXTENSION,
);
export const MetricPreferredDirectionChangeExtension = metricsPlugin.provide(
  METRIC_PREFERRED_DIRECTION_CHANGE_EXTENSION,
);
export const MetricVarianceReductionConfigChangeExtension =
  metricsPlugin.provide(METRIC_VARIANCE_REDUCTION_CONFIG_CHANGE_EXTENSION);
export const MetricMeasurementConfigSuppressExtension = metricsPlugin.provide(
  METRIC_MEASUREMENT_CONFIG_SUPPRESS_EXTENSION,
);
